import { useSelector } from "react-redux";

/** Redux state slice used by `selectAskAiInItemDetailEnabled`. */
export type AskAiItemDetailUserState = {
  userReducer?: {
    getIn?: (path: string[]) => unknown;
  };
};

/**
 * "Ask AI" on record detail panels (Company / Contact / Deal) — sysadmin-only preview until GA.
 * SSOT: `user.sysAdmin` from `GET api/users/me` (`app.sys-admins`). UI-only — APIs unchanged.
 */
export function selectAskAiInItemDetailEnabled(state: AskAiItemDetailUserState): boolean {
  return state.userReducer?.getIn?.(["currentUser", "sysAdmin"]) === true;
}

export function useAskAiInItemDetailEnabled(): boolean {
  return useSelector(selectAskAiInItemDetailEnabled);
}
